import type { TransitionProps } from 'vue';
import { gsap } from 'gsap';

export function usePageTransition(): TransitionProps {
    return {
        name: 'page-transiton',
        mode: 'out-in',
        css: false,
        onBeforeEnter: () => {
            const pageBeforeComplete = usePageBeforeComplete();
            pageBeforeComplete.value = true;
        },
        onEnter: (el, done) => {
            const pageComplete = usePageComplete();

            gsap.timeline({
                paused: true,
                delay: 0.05,
                onComplete: () => {
                    pageComplete.value = true;
                    document.body.dataset.scrollDirection = 'init';
                    document.body.dataset.scrolled = 'false';
                    document.body.classList.remove('is-loading');
                    document.body.classList.remove('hide-pointer-events');
                    done();
                }
            })
                .to(el.parentElement, {
                    autoAlpha: 0,
                    duration: 0
                })
                .to(window, { scrollTo: { y: 0 } })
                .to(el.parentElement, {
                    autoAlpha: 1,
                    duration: 0.3,
                    delay: 0.12,
                    ease: 'sine.in'
                })

                .play();
        },
        onBeforeLeave: () => {
            const pageBeforeComplete = usePageBeforeComplete();
            pageBeforeComplete.value = false;

            document.body.classList.add('is-loading');
            document.body.classList.add('hide-pointer-events');
        },
        onLeave: (el, done) => {
            const pageComplete = usePageComplete();
            const toggleMobileMenu = useToggleMobileMenu();

            gsap.timeline({
                paused: true,
                onComplete: () => {
                    pageComplete.value = false;
                    toggleMobileMenu.value = false;
                    done();
                }
            })
                .to(el.parentElement, {
                    autoAlpha: 0,
                    duration: 0.28,
                    ease: 'sine.out'
                })

                .play();
        }
    };
}
